//异常数据
import _import from '@/utils/import'
const Layout = _import('layout/Layout')
let consumptionData = [
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'consumpRegion',//消费量区域分布
        component: _import('consumptionData/consumpRegion/index'),
        name: 'consumpRegion',
        meta: { 
          title: '消费量区域分布',
          icon: 'widgets'
        }
      },{
        path: 'consumpProvince',//省市数据
        component: _import('consumptionData/consumpProvince/index'),
        name: 'consumpProvince',
        meta: { 
          title: '消费量区域分布',
          icon: 'widgets'
        }
      },{
        path: 'consumpDot',//地市数据
        component: _import('consumptionData/consumpDot/index'),
        name: 'consumpDot',
        meta: { 
          title: '消费量区域分布',
          icon: 'widgets'
        }
      },
      {
        path: 'consumpSite',//搜索主界面
        component: _import('consumptionData/consumpSearch/index'),
        name: 'consumpSite',
        meta: {
          title: '搜索主页',
          icon: 'widgets'
        }
      },
      {
        path: 'consumpSearch',//搜索结果页
        component: _import('consumptionData/consumpSearch/search'),
        name: 'consumpSearch',
        meta: {
          title: '查询结果',
          icon: 'widgets'
        }
      }
    ]
  }
]
export default consumptionData;